import type { LevelDef } from '../levels';

// Pyramid — 15 types × 3 = 45 tiles
// Layer 0: 4×6 base (24)   Layer 1: 3×5 middle (15)   Layer 2: 2×3 cap (6)
export const LEVEL_PYRAMID: LevelDef = {
  id: 'level-pyramid',
  name: 'Pyramid',
  seed: 53,
  tileTypes: 15,
  maxRowX2: 6,
  maxColX2: 10,
  placements: [
    { rowX2: 0, colX2: 0, layer: 0 },
    { rowX2: 0, colX2: 2, layer: 0 },
    { rowX2: 0, colX2: 4, layer: 0 },
    { rowX2: 0, colX2: 6, layer: 0 },
    { rowX2: 0, colX2: 8, layer: 0 },
    { rowX2: 0, colX2: 10, layer: 0 },
    { rowX2: 2, colX2: 0, layer: 0 },
    { rowX2: 2, colX2: 2, layer: 0 },
    { rowX2: 2, colX2: 4, layer: 0 },
    { rowX2: 2, colX2: 6, layer: 0 },
    { rowX2: 2, colX2: 8, layer: 0 },
    { rowX2: 2, colX2: 10, layer: 0 },
    { rowX2: 4, colX2: 0, layer: 0 },
    { rowX2: 4, colX2: 2, layer: 0 },
    { rowX2: 4, colX2: 4, layer: 0 },
    { rowX2: 4, colX2: 6, layer: 0 },
    { rowX2: 4, colX2: 8, layer: 0 },
    { rowX2: 4, colX2: 10, layer: 0 },
    { rowX2: 6, colX2: 0, layer: 0 },
    { rowX2: 6, colX2: 2, layer: 0 },
    { rowX2: 6, colX2: 4, layer: 0 },
    { rowX2: 6, colX2: 6, layer: 0 },
    { rowX2: 6, colX2: 8, layer: 0 },
    { rowX2: 6, colX2: 10, layer: 0 },
    { rowX2: 1, colX2: 1, layer: 1 },
    { rowX2: 1, colX2: 3, layer: 1 },
    { rowX2: 1, colX2: 5, layer: 1 },
    { rowX2: 1, colX2: 7, layer: 1 },
    { rowX2: 1, colX2: 9, layer: 1 },
    { rowX2: 3, colX2: 1, layer: 1 },
    { rowX2: 3, colX2: 3, layer: 1 },
    { rowX2: 3, colX2: 5, layer: 1 },
    { rowX2: 3, colX2: 7, layer: 1 },
    { rowX2: 3, colX2: 9, layer: 1 },
    { rowX2: 5, colX2: 1, layer: 1 },
    { rowX2: 5, colX2: 3, layer: 1 },
    { rowX2: 5, colX2: 5, layer: 1 },
    { rowX2: 5, colX2: 7, layer: 1 },
    { rowX2: 5, colX2: 9, layer: 1 },
    { rowX2: 2, colX2: 3, layer: 2 },
    { rowX2: 2, colX2: 5, layer: 2 },
    { rowX2: 2, colX2: 7, layer: 2 },
    { rowX2: 4, colX2: 3, layer: 2 },
    { rowX2: 4, colX2: 5, layer: 2 },
    { rowX2: 4, colX2: 7, layer: 2 }
  ],
};